module.exports = __webpack_public_path__ + "ve.svg?d384c6ce97ba0ca4aecbc188e84a0670";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/ve.svg
// module id = 1430
// module chunks = 0